<template>
  <FullScreen>
    <div class="th-auth-content w-full md:w-4/5 lg:w-1/3">
      <div class="th-auth-card">
        <template v-for="obj in titles">
          <template v-if="obj.name === currentAuthRouteName">
            <h3
              style="margin-bottom: 30px !important"
              class="text-center"
              v-if="obj.title"
              :key="obj.name"
            >
              {{ obj.title }}
            </h3>
            <template v-else>
              <template v-for="child in obj.children">
                <h3
                  style="margin-bottom: 30px !important"
                  class="text-center"
                  :key="child.name"
                  v-if="child.isEmail"
                >
                  {{ child.title }}
                </h3>
              </template>
            </template>
          </template>
        </template>
        <router-view></router-view>
      </div>
    </div>
  </FullScreen>
</template>

<script>
const FullScreen = () => import('@/components/App/FullScreen')
const titles = [
  {
    name: 'Masuk',
    title: 'Masuk ke Akun Anda',
  }, {
    name: 'Daftar',
    title: 'Daftar dan Mulai Belajar',
  }, {
    name: 'Lupa Sandi',
    children: [
      {
        title: 'Lupa Kata Sandi',
        isEmail: true,
      }, {
        title: 'Lupa Kata Sandi',
        isEmail: false,
      },
    ],
  },
]

export default {
  data() {
    return {
      titles,
      currentAuthRouteName: '',
    }
  },
  components: { FullScreen },
  watch: {
    '$route'(to, from) {
      this.currentAuthRouteName = to.name
      // console.log(to, this.currentAuthRouteName, 'masuk watch')
    },
  },
  created() {
    // console.log(this.$router.history.current, 'masuk created')
    this.currentAuthRouteName = this.$router.history.current.name
  },
}
</script>

<style>
</style>
